export default "__VITE_ASSET__PlttJnhx__"